import * as React from 'react';
import {Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import {DisplayFeature, DisplayFeatureType, SubmitComment, UserSession} from '../domain';
import {
    OnNewFeatureComment,
    onNewFeatureComment,
    OnNewFeatureTypeComment,
    onNewFeatureTypeComment
} from '../../../actions/actions';
import FeaturesState from '../domain/FeaturesState';
import {
    contractId,
    displayFeatureTypeFromDisplayFeatureForComment,
    selectedFeatures,
    user, featureOrTypeForComments
} from '../selectors';

interface CommentFormStateProps {
    user: UserSession;
    contractId: string;
    singleFeatureComments: DisplayFeature | DisplayFeatureType | null;
    selectedFeatures: DisplayFeature[];
    selectedFeaturesParentType: DisplayFeatureType | null;
}

interface CommentFormDispatchProps {
    submitFeatureComment: OnNewFeatureComment;
    submitFeatureTypeComment: OnNewFeatureTypeComment;
}

type CommentFormProps = CommentFormStateProps & CommentFormDispatchProps;

interface CommentFormState {
    comment: string;
    error: boolean;
    copyComment: boolean;
}
class CommentForm extends React.Component<CommentFormProps, CommentFormState> {

    constructor(props: CommentFormProps) {
        super(props);
        this.state = CommentForm.defaultState();
        this.commentChanged = this.commentChanged.bind(this);
        this.isErrorChanged = this.isErrorChanged.bind(this);
        this.copyCommentChanged = this.copyCommentChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    private static defaultState() {
        return {
            comment: '',
            error: false,
            copyComment: false
        };
    }

    commentChanged (event: React.ChangeEvent<HTMLTextAreaElement>) {
        const value: string = event.target.value;
        this.setState({...this.state, comment: value});
    }
    isErrorChanged (event: React.ChangeEvent<HTMLInputElement>) {
        const value: boolean = event.target.checked;
        this.setState({...this.state, error: value});
    }

    copyCommentChanged (event: React.ChangeEvent<HTMLInputElement>) {
        const value: boolean = event.target.checked;
        this.setState({...this.state, copyComment: value});
    }

    handleSubmit(event: React.FormEvent) {
        event.preventDefault();
        const {comment, error, copyComment} = this.state;

        // If singleFeatureComments is null, we have more than one type or feature chosen, and cannot add comments to them
        if (comment.length > 0 && this.props.singleFeatureComments !== null) {
            if ('id' in this.props.singleFeatureComments) {
                if (this.props.selectedFeaturesParentType) {
                    this.props.submitFeatureComment(
                        new SubmitComment(
                            this.props.contractId,
                            this.props.singleFeatureComments.id,
                            'FEATURE',
                            this.props.selectedFeaturesParentType.destination,
                            this.props.user.username,
                            error,
                            comment,
                            copyComment
                        )
                    );
                }
            } else {
                this.props.submitFeatureTypeComment(comment, error, copyComment, this.props.singleFeatureComments.typeId);
            }
        }

        this.setState(CommentForm.defaultState());
    }

    render() {
        const commentResource: 'FEATURE_TYPE_COMMENT' | 'FEATURE_COMMENT' = 'id' in this.props.singleFeatureComments
            ? 'FEATURE_COMMENT'
            : 'FEATURE_TYPE_COMMENT';
        const showForm = this.props.user.hasPermission(commentResource + ':CREATE', this.props.contractId);


        if (this.props.singleFeatureComments === null || !showForm) {
            return null;
        }


        const objectId = 'id' in this.props.singleFeatureComments
            ? this.props.singleFeatureComments.id
            : this.props.singleFeatureComments.typeId;

        const canMarkAsError = this.props.user.hasPermission(commentResource + ':MARK_AS_ERROR', this.props.contractId);
        const showCommentCopy = commentResource === 'FEATURE_COMMENT' && this.props.selectedFeatures?.filter(feature => feature.id !== objectId).length > 0;

        return (
            <form className="newComment" onSubmit={this.handleSubmit}>
                <label htmlFor={'comment-text-area'}>Kommentar</label>
                <textarea id={'comment-text-area'} className="form-control" rows={7} value={this.state.comment} onChange={this.commentChanged} />
                {!canMarkAsError ? null : <div><label className="checkbox-inline markaserror"><input type="checkbox" onChange={this.isErrorChanged} checked={this.state.error}/>Markér som feil</label></div>}
                {!showCommentCopy ? null : <div><label className="checkbox-inline copycomment"><input type="checkbox" onChange={this.copyCommentChanged} checked={this.state.copyComment}/>Kopier kommentar til valgte vegobjekter</label></div>}
                <Button className="pull-right" type="submit" >Lagre</Button>
            </form>
        );
    }
}

const mapStateToProps = (state: FeaturesState): CommentFormStateProps => ({
    user: user(state),
    contractId: contractId(state),
    singleFeatureComments: featureOrTypeForComments(state),
    selectedFeatures: selectedFeatures(state),
    selectedFeaturesParentType: displayFeatureTypeFromDisplayFeatureForComment(state)
});
const mapDispatchToProps: CommentFormDispatchProps = {
    submitFeatureComment: onNewFeatureComment,
    submitFeatureTypeComment: onNewFeatureTypeComment
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentForm);
